<template>
  <div :id="id" class="uk-flex-top" uk-modal>
    <div class="uk-modal-dialog uk-margin-auto-vertical">
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-header" v-if="hasHeaderSlot">
        <slot name="header"></slot>
      </div>
      <div class="uk-modal-body" v-if="hasBodySlot">
        <slot name="body"></slot>
      </div>
      <div class="uk-modal-footer" v-if="hasFooterSlot">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ConfirmationModal',
  components: {
  },
  computed: {
    hasBodySlot() {
      return !!this.$slots.body
    },
    hasHeaderSlot() {
      return !!this.$slots.header
    },
    hasFooterSlot() {
      return !!this.$slots.footer
    }
  },
  data() {
    return {
    }
  },
  props: ['id']
}
</script>

<style scoped lang="less">
@import "../../assets/less/theme.less";

</style>
